var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadApps = function SvgDownloadApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M8.71 4.112H6.375v2.895l.78-.78a.377.377 0 0 1 .53 0 .377.377 0 0 1 0 .53l-1.42 1.425a.3.3 0 0 1-.08.06s-.005 0-.005.005l-.035.015a.34.34 0 0 1-.145.03.3.3 0 0 1-.14-.03c-.01 0-.02-.01-.035-.015H5.82v-.005a.5.5 0 0 1-.08-.055v-.005h-.005l-1.42-1.425a.377.377 0 0 1 0-.53.38.38 0 0 1 .535 0l.775.78V4.112H3.29c-1.125 0-2.04.915-2.04 2.035v2.375c0 1.13.915 2.045 2.04 2.045h5.42c1.125 0 2.04-.915 2.04-2.035v-2.38c0-1.125-.915-2.04-2.04-2.04M6.375 2.058a.374.374 0 1 0-.75 0v2.054h.75z",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadApps;